import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { CartFunnelHeaderBlockConfig } from '@front-platform/content-builder';
import { cartFunnelHeaderBlockResolveConfig } from '@front-platform/content-builder';
import { combineLatest } from 'rxjs';
import { Router } from '@angular/router';
import { Component, input, computed } from '@angular/core';
import { take, tap } from 'rxjs/operators';

import { Paths } from '@config/paths.config';
import { CartFunnelStoreSelector } from '@common/selectors/cart-funnel.selector';
import { RouterHelperService } from '@core/services/router-helper/router-helper.service';
import { CartFunnelStoreDispatcher } from '@common/dispatchers/cart-funnel.dispatcher';
import { AnalyticsService } from '@core/services/app/analytics.service';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
export interface CartFunnelHeaderBlockRuntimeConfig {}

export type CartFunnelHeaderBlockConfigInput = Partial<
  Omit<CartFunnelHeaderBlockConfig, keyof CartFunnelHeaderBlockRuntimeConfig> &
    CartFunnelHeaderBlockRuntimeConfig
>;
export type CartFunnelHeaderBlockResolvedConfig = Omit<
  CartFunnelHeaderBlockConfig,
  keyof CartFunnelHeaderBlockRuntimeConfig
> &
  Partial<CartFunnelHeaderBlockRuntimeConfig>;
export interface CartFunnelHeaderBlockContract extends ConfigComponentContract<
  CartFunnelHeaderBlockConfigInput,
  CartFunnelHeaderBlockResolvedConfig
> {}

@Component({
  selector: 'app-cart-funnel-header-block',
  templateUrl: './cart-funnel-header-block.component.html',
  standalone: false,
})
export class CartFunnelHeaderBlockComponent implements CartFunnelHeaderBlockContract {
  readonly config = input<CartFunnelHeaderBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    CartFunnelHeaderBlockConfig,
    CartFunnelHeaderBlockRuntimeConfig
  >(cartFunnelHeaderBlockResolveConfig, () => ({ config: this.config() }));
  textColor = computed(
    () => this.resolvedConfig()['text_color'] as unknown as IContentBuilderFieldColor,
  );
  backgroundColor = computed(
    () => this.resolvedConfig()['background_color'] as unknown as IContentBuilderFieldColor,
  );

  constructor(
    private readonly router: Router,
    private readonly routerHelper: RouterHelperService,
    private cartFunnelSelector: CartFunnelStoreSelector,
    private cartFunnelDispatcher: CartFunnelStoreDispatcher,
    private readonly analyticsService: AnalyticsService,
  ) {}

  back(): void {
    combineLatest([
      this.cartFunnelSelector.selectDisplayableStepsIds,
      this.cartFunnelSelector.selectActiveStepId,
    ])
      .pipe(
        take(1),
        tap(([displayableStepsIds, activeStepId]) => {
          if (!activeStepId) {
            this.router.navigate([this.routerHelper.translateRoute(Paths.Cart)]);
            return;
          }
          const activeStepIndex = displayableStepsIds.indexOf(activeStepId);

          if (activeStepIndex === 0) {
            this.router.navigate([this.routerHelper.translateRoute(Paths.Cart)]);
            return;
          }

          if (activeStepIndex === -1) {
            this.router.navigate([this.routerHelper.translateRoute(Paths.Cart)]);
            return;
          }

          this.cartFunnelDispatcher.setActive(displayableStepsIds[activeStepIndex - 1]);
        }),
      )
      .subscribe();
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(CartFunnelHeaderBlockComponent, { 'keyAliases': {} });
